import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { TOLL_PATH } from '../../../../config/paths';

const TollToolBar = ({ tollId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${TOLL_PATH}/${tollId}/edit`} />{' '}
    </div>
  </ButtonToolbar>
);

TollToolBar.propTypes = {
  tollId: PropTypes.number.isRequired,
};

export default TollToolBar;
